import { __decorate } from "tslib";
import _ from 'lodash';
import Vue from 'vue';
import { Tooltip } from 'element-ui';
import { Icon as PzIcon, ImageLoader } from 'patsnap-biz';
import { rvTrack } from 'track';
import { RavenInsertMeta } from 'library-@/services/sentry';
import cellConfs from '@/presentation/components/folders/excelCells/cells.config';
import { addImageHistoryApi } from '@cores/apis/others_api/core_basic';
import { formatePdfImageData } from '@/infrastructure/utils/pdfImageFormate';
import defaultThumbImg from '@/presentation/assets/images/pic_placeholder_120.gif';
import { provide } from '@/inversify.config';
import { ANALYTICS_URI } from '@cores/constants/envConfig';
import { IMAGE_SEARCH_PATENT_TYPE } from '@cores/constants/imageSearch';
import '@patsnap-ui/icon/assets/solid/ResizeMaximum.svg';
import '@patsnap-ui/icon/assets/solid/ImageExist.svg';
import '@patsnap-ui/icon/assets/solid/SmartSearch.svg';
import { useUploadPermission } from '@/presentation/composables/use-upload-permission';
const ElTooltip = Tooltip;
export const HsTableServiceSymbol = Symbol.for('HsTableService');
let HsTableService = class HsTableService {
    constructor() {
        this.hsInstance = null;
        this.hsSettings = null;
        this.row = null;
        this.col = null;
        this.$vm = null;
        this.selectedIds = [];
        this.selectedRowIds = [];
    }
    destroy() {
        this.hsInstance = undefined;
        this.hsSettings = undefined;
        this.$vm = undefined;
    }
    getCellDom(row, col) {
        return this.hsInstance.getCell(row, col, true);
    }
    buildFoucsedCellTools(row, col, tableSize) {
        this.row = row;
        this.col = col;
        if (!this.hsInstance || !this.hsInstance.rootElement)
            return;
        const td = this.getCellDom(row, col);
        if (!td)
            return;
        let toolsDom = td.querySelector('#hs_tools_container');
        if (!toolsDom) {
            toolsDom = document.createElement('div');
            toolsDom.id = 'hs_tools_container';
            toolsDom.setAttribute('data-row', row);
            toolsDom.setAttribute('data-col', col);
            td.appendChild(toolsDom);
        }
        const prop = this.hsInstance.colToProp(col);
        if (prop !== 'PN' && tableSize !== 'auto')
            this.zoomCellTool(toolsDom);
        const propTools = _.get(cellConfs, `[${prop}].tools`, []);
        if (propTools.includes('viewThumb'))
            this.viewThumbTool(toolsDom);
        if (propTools.includes('searchImage'))
            this.searchImageTool(toolsDom);
        const data = this.hsInstance.getSourceDataAtRow(row);
        this.$vm.$eventHub.$emit('SpaceDetail:ZoomCell:Change', {
            row: this.row,
            col: this.col,
            name: prop,
            td: this.cloneCellNode(td, data, this.row, this.col, prop),
            data,
        });
    }
    destoryFoucsedCellTools() {
        this.row = null;
        this.col = null;
        if (!this.hsInstance || !this.hsInstance.rootElement)
            return;
        const toolsDom = this.hsInstance.rootElement.querySelector('#hs_tools_container');
        if (toolsDom) {
            const toolsParentDom = toolsDom.parentNode;
            toolsParentDom && toolsParentDom.removeChild(toolsDom);
        }
    }
    addToolItem(container, idName, iconName, tip, handler = _.noop) {
        const toolDom = container.querySelector(`#${idName}`);
        if (!toolDom) {
            const icon = this.svgIconDom({
                id: idName,
                width: 20,
                icon: iconName,
                tip,
            });
            icon.addEventListener('click', handler);
            container.appendChild(icon);
        }
    }
    zoomCellTool(container) {
        this.addToolItem(container, 'hs_tool_zoom_cell', 'SolidResizeMaximum', this.$vm.$t('global.btn.expand'), () => {
            const data = this.hsInstance.getSourceDataAtRow(this.row);
            const name = this.hsInstance.colToProp(this.col);
            const td = this.getCellDom(this.row, this.col);
            this.$vm.$eventHub.$emit('SpaceDetail:ZoomCell', {
                row: this.row,
                col: this.col,
                name,
                data,
                td: this.cloneCellNode(td, data, this.row, this.col, name),
                show: true,
            });
        });
    }
    viewThumbTool(container) {
        this.addToolItem(container, 'hs_tool_view_thumb', 'SolidImageExist', this.$vm.$t('workspace.tools.btn.preview'), () => {
            const { PDF_IMAGE_COUNT, PATENT_ID } = this.hsInstance.getSourceDataAtRow(this.row);
            if (!PDF_IMAGE_COUNT)
                return;
            rvTrack('Click Quick View All Images In Workspace');
            this.$vm.$eventHub.$emit('SpaceDetail:QuickViewAllImage', {
                imageCount: PDF_IMAGE_COUNT,
                patentId: PATENT_ID,
            });
        });
    }
    searchImageTool(container) {
        const data = this.hsInstance.getSourceDataAtRow(this.row) || {};
        const { PATENT_ID, IMAGE_ID, PATSNAP_IMAGE_120 } = data;
        if (!IMAGE_ID || !PATSNAP_IMAGE_120)
            return;
        const { enableImageDiscovery } = useUploadPermission();
        if (!enableImageDiscovery.value)
            return;
        const types = _.get(data, 'TYPE') || [];
        let isD = false;
        for (let i = 0; i < types.length; i++) {
            if (/^[a-zA-Z]{2}D$/.test(types[i])) {
                isD = true;
            }
        }
        return this.addToolItem(container, 'hs_tool_search_image', 'SolidSmartSearch', this.$vm.$t('snapBusiness.imageSearchMap.searchImage'), () => {
            const patentType = isD ? IMAGE_SEARCH_PATENT_TYPE.design : IMAGE_SEARCH_PATENT_TYPE.utilityModels;
            addImageHistoryApi({
                patentId: PATENT_ID,
                imgId: IMAGE_ID,
                patent_type: patentType,
            });
            let discoveryUrl = `${ANALYTICS_URI}/search/image/result?searchType=imageDiscovery&patentId=${PATENT_ID}&patent_type=${patentType}`;
            if (IMAGE_ID) {
                discoveryUrl += `&imgId=${IMAGE_ID}`;
            }
            window.open(discoveryUrl);
            RavenInsertMeta('Image Search Result', 'Click Image Search Map', {
                discoveryUrl,
                source: 'Workspace',
            });
        });
    }
    svgIconDom(attrs = {}) {
        const IconTemplate = Vue.extend({
            components: {
                PzIcon,
                ElTooltip,
            },
            render() {
                const { ...props } = attrs;
                const icon = <span class="hs-tool-item"><PzIcon {...{ props }}/></span>;
                return attrs.tip
                    ? (<ElTooltip placement="top" enterable={false} visible-arrow={false} popper-class="pt-ui-tooltip no-wrap">
                            <div slot="content">
                                {attrs.tip}
                            </div>
                            {icon}
                        </ElTooltip>)
                    : (icon);
            },
        });
        const iconVue = new IconTemplate().$mount();
        return iconVue.$el;
    }
    buildImageLoader(attrs = {}) {
        const ImgTemplate = Vue.extend({
            components: {
                ImageLoader,
            },
            data() {
                return {
                    loadingImg: defaultThumbImg,
                };
            },
            render() {
                const patentImg = _.get(attrs, 'PATSNAP_IMAGE_120') || _.get(attrs, 'PATSNAP_IMAGE') || { originUrl: '' };
                patentImg.originUrl = _.get(attrs, 'PATSNAP_IMAGE.url');
                const imageLoaderData = formatePdfImageData(patentImg);
                // @ts-ignore
                const { type, model, src, originSrc } = imageLoaderData;
                return (<div class="THUMB_120-cell">
                        {this.loadingImg ? (<img src={this.loadingImg} style="width:100%;"/>) : null}
                        {type === 'patsnap'
                        ? <ImageLoader item={model} onImageLoaded={() => { this.loadingImg = null; }} size={{ width: 500, height: 350 }}></ImageLoader>
                        : <img src={originSrc || src} onLoad={() => { this.loadingImg = null; }} style="width:100%;"/>}
                    </div>);
            },
        });
        const imgVue = new ImgTemplate().$mount();
        return imgVue.$el;
    }
    cloneCanvas(oldCanvas) {
        const newCanvas = document.createElement('canvas');
        const context = newCanvas.getContext('2d');
        newCanvas.width = oldCanvas.width;
        newCanvas.height = oldCanvas.height;
        context.drawImage(oldCanvas, 0, 0);
        return newCanvas;
    }
    cloneCellNode(td, data, row, col, name) {
        const clone_node = td.cloneNode(true);
        const node = clone_node.firstChild;
        // THUMB120 canvas
        if (name === 'THUMB_120') {
            return this.buildImageLoader(data);
        }
        // IPC CPC LOC UPC GBC CPC_ALL
        const CLASSIFICATION_TYPES = ['IPC', 'CPC', 'CPC_ALL', 'LOC', 'UPC', 'GBC', 'ADC', 'TTC', 'SEIC'];
        let classification_nodes;
        const CLASSIFICATION_PREVIEW = 'classification:preview:trigger';
        for (const k of CLASSIFICATION_TYPES) {
            classification_nodes = node.querySelectorAll(`[data-link-type="${k}"]`);
            if (classification_nodes && classification_nodes.length > 0)
                break;
        }
        for (let i = 0; i < classification_nodes.length; i++) {
            const classification_node = classification_nodes[i];
            const PATENT_ID = classification_node.attributes['data-patent-id'].value;
            const type = classification_node.attributes['data-link-type'].value;
            const text = classification_node.attributes['data-link-data'].value;
            let currentData;
            if (['ADC', 'TTC', 'SEIC'].includes(name)) {
                currentData = _.find(data[name], item => { return item.description === text; });
            }
            const value = currentData ? _.get(currentData, 'code') : text;
            const topicTips = _.get(currentData, 'topic_tips', '');
            classification_node.onmouseenter = event => {
                if (name === 'SEIC' || (name === 'TTC' && !topicTips))
                    return;
                this.$vm.$eventHub.$emit(CLASSIFICATION_PREVIEW, { PATENT_ID, type, name: value, topicTips, open: true }, event);
            };
            classification_node.onmouseleave = event => this.$vm.$eventHub.$emit(CLASSIFICATION_PREVIEW, { PATENT_ID, type, name: value, topicTips, open: false }, event);
        }
        return node;
    }
    calcSelectedIds(id_key = 'PATENT_ID') {
        const { from, to } = this.hsInstance.getSelectedRangeLast();
        const rows = [from.row, to.row];
        const minRow = _.min(rows);
        const maxRow = _.max(rows);
        const _selectedRowIds = [];
        for (let i = minRow; i <= maxRow; i++) {
            _selectedRowIds.push(i);
        }
        this.selectedRowIds = _selectedRowIds;
        const sourceData = _.slice(this.hsInstance.getSourceData(), minRow, maxRow + 1);
        this.selectedIds = sourceData.map((item) => {
            return _.get(item, id_key);
        });
    }
};
HsTableService = __decorate([
    provide(HsTableServiceSymbol)
], HsTableService);
export { HsTableService };
